import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import {
  isAdminSelector,
  isManagerSelector,
  deviceModelsSelector,
  protocolsSelector,
} from '../selectors';
import { openModelAddModal, updateModel, deleteModel } from '../actions/entry';
import Models from '../components/DeviceModels';

const mapStateToProps = (state) => {
  const isAdmin = isAdminSelector(state);
  const isManager = isManagerSelector(state);
  let models = deviceModelsSelector(state);
  const protocols = protocolsSelector(state);

  models = models.map((model) => {
    let { protocolId } = model;
    if (protocolId?.id) protocolId = protocolId.id;
    const protocolName = protocols.find((protocol) => protocol.id === protocolId)?.name;
    return {
      ...model,
      protocolName,
    };
  });

  return {
    items: models,
    protocols,
    canView: isAdmin || isManager,
    canEdit: isAdmin,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      onAdd: openModelAddModal,
      onUpdate: (data) => updateModel(data.id, data),
      onDelete: (data) => deleteModel(data.id),
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(Models);
